export default {
  name: 'IconBase',
  props: {
    width: {
      type: String,
      default: '24px',
    },
    height: {
      type: String,
      default: '24px',
    },
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  // eslint-disable-next-line
  render: function (h) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg"
           width={this.width}
           height={this.height}
           viewBox={this.viewBox}
           aria-labelledby={this.label}
           role="presentation"
      >
        <g fill={this.color} domPropsInnerHTML={this.rawSvgPath}>
        </g>
      </svg>)
  },
}